import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, NgZone, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import * as signalR from '@microsoft/signalr';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { Application, SignalRHubEventType } from 'projects/Autofacets-Core/src/app/utils/enums';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { themes } from '../helper/Enums/theme.const';
import { GlobalService } from '../helper/Services/global.service';
import { SecureStorage } from '../helper/Services/secure-storage';
import { BrandViewModel } from '../Models/brand';
import { NotificationRequestViewModel } from '../Models/notification-request-view-model';
import { CommonLocalizationService } from '../Services/localization/common-localization.service';
import { OrderStatusService } from '../Services/orderstatus/order-status.service';
import { Features } from '../../../../Widget/src/app/business-entities/step.class';
import * as CommonEnums from '../../../../Autofacets-Core/src/app/utils/enums';
import { NgxSpinnerService } from 'ngx-spinner';
import { CurrentLanguage } from '../../../../Autofacets-Core/src/app/common-services/current-language.service';
import {CallDealerLogEntryRequestModel} from '../Models/call-dealer-log-entry-requestModel'
import { NotificationViewComponent } from '../Views/notification/view-all-notifications/notification-view/notification-view.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

   @Output() notificationChangeEvent = new EventEmitter<any>();
   headerInfo = Object();
  brandList: BrandViewModel[]
  currentLang: string;
  selectedLanguageText: string;
  selectedLanguageFlag: string;
  selectedLangExpireDate = new Date();
  languageModel: any;
  isLanguageFlag: boolean = false;
  licensePlateClass:string;
  notificationCount: number = 0;
  notificationPopupOpen: boolean = false;
  notificationList: any =[];
  VehicleBrandLogo: string = '';
  logoUrlLink: string;
  features: Features[] = [];
  EnableCookieConsent:boolean = false;
  isProd = false;
  @Input() showorderstatus:any;
  @Input() notificationheader:any;
  notificationRequestModel:NotificationRequestViewModel =
  {
    userId: null,
    isRead: null,
    searchTerm: ""
  };
  constructor(
    private gService: GlobalService,
    private orderService: OrderStatusService,
    private commonLocalizationService: CommonLocalizationService,
    private cookieService: CookieService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private secureStorage: SecureStorage,
    private globalSetting:GlobalSetting,
    private _eref: ElementRef,
    private router: Router,
    public spinner: NgxSpinnerService,
    private currentLng: CurrentLanguage,
    private zone: NgZone
  ) { }

  ngOnInit(): void {
    this.isProd = environment.production;
    this.logoUrlLink = this.globalSetting.getGlobalLogoUrlLink();
    this.selectedLangExpireDate.setDate(this.selectedLangExpireDate.getDate() + 1);
    this.licensePlateClass=this.globalSetting.getGlobalLicencePlate();
    this.getBrands();
    this.GetFeature();
    this.currentLng.featureList.subscribe((response) => {
      if(response?.length > 0){
        this.EnableCookieConsent = response?.find(x => x.featureCode === CommonEnums.FeatureCode.EnableCookieConsent)?.isActive;
        if(this.EnableCookieConsent){
          let node = document.createElement('script'); 
          node.src = EnvSetting.Tracker_CookieScript_Key; 
          node.type = 'text/javascript'; 
          document.getElementsByTagName('head')[0].appendChild(node);
         }
      }
    })
    if (EnvSetting.language.LanguageOverRule) {
      this.currentLang = EnvSetting.language.LanguageOverRuleDefault;
      this.cookieService.set('userSelectedLanguage', this.currentLang, this.selectedLangExpireDate, '/', '', false,"Strict");
    }
    else {
      this.isLanguageFlag = true;
      this.commonLocalizationService.getAllLanguages().subscribe(res => {
        this.languageModel = res;
        if (this.isCookiesExist()) {
          this.currentLang = this.cookieService.get('userSelectedLanguage');
          this.selectedLanguageText = this.languageModel.find(search => search.key === this.currentLang).value;
          this.selectedLanguageFlag = this.getFlagImage(this.languageModel.find(search => search.key === this.currentLang).flagName);
        } else {
          this.currentLang=  this.gService.customerDefaultLanguage ?? EnvSetting.STATUSTRACKER_DEFAULT_LANGUAGE_CONFIG;
          this.selectedLanguageText = this.languageModel.find(search => search.key === this.currentLang).value;
          this.selectedLanguageFlag = this.getFlagImage(this.languageModel.find(search => search.key === this.currentLang).flagName);
        }
        this.cookieService.set('userSelectedLanguage', this.currentLang, this.selectedLangExpireDate, '/', '', false,"Strict");
        this.translate.use(this.currentLang);

        this.cdr.detectChanges();
      });
    }
  }

  loadcomponent()
  {
  this.notificationPopupOpen=false;
  this.router.navigateByUrl('/view-all-notifications');
  }
  async markAllRead(){
    if (this.headerInfo) {
      if (this.notificationCount > 0) {
        this.orderService.notificationMarkAllAsRead().subscribe(          
          (response)=>{
            if (response) {
              this.GetCustomerNotifications();
            }
          }
        );
      }
    }
  }

  onNotificationClick() {
    this.notificationPopupOpen = !this.notificationPopupOpen;
  }
  
  @HostListener('document:click', ['$event'])
  onNotificationClose(event) {
    if (event) {
      if (!this._eref.nativeElement.getElementsByClassName('notification-box')[0].contains(event.target)) {
        this.notificationPopupOpen = false;
      }
    }
    else{
      this.notificationPopupOpen = false;
    }
  }

  getFlagImage(flag: string) {
    let uri = "assets/images/countryflags/"
    return uri + flag;
  }
  getBrands() {
    let appintiInfo = this.gService.getAppInitialData;    
    this.getOrderHeaderInfo(appintiInfo);
  }
  private getOrderHeaderInfo(info: any) {
    if (info) {      
      this.orderService.getOrderStatusHeaderDetails().subscribe(res => {
        if (res) {
          this.orderService.orderDetails.next(res);
          let mapperData = this.orderDetailsDataMapper(res);
          this.headerInfo = {
            numberPlate: info.VehicleId,
            vbrand: mapperData.vbrand,
            customerGuid: mapperData.customerGuid,
            customerName: mapperData.customerName,
            dealerName: mapperData.dealerName,
            dealerMobile: mapperData.dealerMobile,
            dealerPhoneNo: mapperData.dealerPhoneNo,
            theme: mapperData.theme,
            repairStatusId: mapperData.repairStatusId,
            orderNumber: info.RepairId,
            isDealerActive:mapperData.isDealerActive,
            vehileBrand: mapperData.vehileBrand
          }
          this.notificationChangeEvent.emit(this.headerInfo);
          this.orderService.dealerPhoneNo=this.headerInfo.dealerPhoneNo;
        }
      }, _error => {
        this.headerInfo = null;
      },
      ()=>{
        this.initNotificationConfig();
      });
    }
    else { this.headerInfo = null; }

  }

  private orderDetailsDataMapper(orderInfo: any) {
    if (orderInfo) {
      const cTheme = this.secureStorage.getKeyData('cTheme');
      let single = Object();
      single.vbrand = orderInfo.vehicleImageSource;
      single.customerGuid = orderInfo.customerGuid;
      single.customerName = orderInfo.customerName;
      single.dealerName = orderInfo.dealerName;
      single.dealerMobile = orderInfo.mobileNumber;
      single.dealerPhoneNo = orderInfo.landlineNumber;
      single.repairStatusId = orderInfo.repairStatusId
      single.theme = themes[cTheme.code];
      single.isDealerActive=orderInfo.isDealerActive;
      single.vehileBrand = orderInfo.vehileBrand;
     return single;

    }
  }

  CallDealerLogEntry(){
    let request:CallDealerLogEntryRequestModel ={
      dealerPhone:this.headerInfo?.dealerPhoneNo
    }
    this.orderService.callDealerLogEntry(request).subscribe();
  }

  ChangeLanguage(languageCode: string) {
    this.cookieService.set('userSelectedLanguage', languageCode, this.selectedLangExpireDate, '/', '', false,"Strict");
    this.translate.use(languageCode);
    this.currentLang = languageCode;
    this.selectedLanguageText = this.languageModel.find(search => search.key === languageCode).value;
    this.selectedLanguageFlag = this.getFlagImage(this.languageModel.find(search => search.key === languageCode).flagName);
    this.cdr.detectChanges();
  }

  private isCookiesExist(): boolean {
    return this.cookieService.check('userSelectedLanguage');
  }

  async GetFeature(){
    this.secureStorage.removeKey('feature');
    this.spinner.show();
    await this.commonLocalizationService.getFeatures().then((res)=>{
      if(res.responseObject.errorCount === 0){
        this.features = res.responseObject.result;
        if(this.features && this.features.length >0){
            this.secureStorage.setKeyData('feature', this.features);
            this.currentLng.featureList.next(this.features);
            if (this.secureStorage.getKeyData('feature')) {
              this.features = this.secureStorage.getKeyData('feature');
            }
        }
      }
    })
    this.spinner.hide();
  }

  onInvoiceClick() {
    this.orderService.invoiceClicked.next(true);
  }
  //#region  Push Notification
  
  initNotificationConfig(){
    if (this.headerInfo) {
      const userId = `${this.headerInfo.orderNumber}|${this.headerInfo.customerGuid}`;
      this.GetCustomerNotifications();
      if (userId) {
        const connection = new signalR.HubConnectionBuilder()
          .configureLogging(signalR.LogLevel.Critical)
          .withUrl(`${EnvSetting.PUSH_NOTIFICATION_API_URI}PushNotification?userId=${userId}`)
          .withAutomaticReconnect()
          .build();

        connection.start().catch(function (err) {
          return console.log(err);
        }).then(function () {
          connection.invoke('GetConnectionId');
        });
        this.globalSetting.signalrConnectionTracker.next(connection);
        connection.on(SignalRHubEventType.UserNotification, (_data) => {
          this.GetCustomerNotifications();
        });
        connection.on(SignalRHubEventType.DocumentUploaded, (data) => {
          this.DocumentUploaded(data);
        });
        connection.on(SignalRHubEventType.AppointmentRemoved, (data) => {
          this.OnAppointmentRemoved(data);
        });
      }
    }
  }

  DocumentUploaded(data){
    if (data.appointmentGuid == this.headerInfo?.appointmentGuid) {
      this.orderService.GetDocumentCount().then((res)=>{
        if (res?.responseObject?.length > 0) {
          this.orderService.DemandWiseDocumentCountList.next(res.responseObject);
        }
      })
    }
  }
  OnAppointmentRemoved(data){
    console.log("this.gService.getAppInitialData",this.gService.getAppInitialData);
    console.log("data",data)
    if (this.gService.getAppInitialData?.AppointmentGuid == data.appointmentId) {
      let modelHeadermsg = this.translate.instant('lblAppointmentDeleted');
      let modelBodymsg = this.translate.instant('lblAppointmentDeletedMsg');
      const updatedModalRef = this.modalService.open(NgInfoModalContent, { backdrop: false, keyboard: false, centered: true });
      updatedModalRef.componentInstance.modelHeader = modelHeadermsg;
      updatedModalRef.componentInstance.modelBody = modelBodymsg;
      updatedModalRef.result.then((_result) => { 
        // This is intentional
      }, (_reason) => {
        this.zone.run(() => {
          this.gService.setAppInitialData(null);
          this.router.navigate(['/error-page']);
        });
      });
    }
  }

  GetCustomerNotifications(){
    if (this.headerInfo) {
      const userId = `${this.headerInfo.orderNumber}|${this.headerInfo.customerGuid}`;
      if (userId) {
        this.notificationRequestModel.userId=userId;
        this.notificationRequestModel.isRead="UNREAD";
        this.orderService.getCustomerNotifications(this.notificationRequestModel).toPromise().then(
          (res)=>{
            if (res?.responseObject){
              res.responseObject.forEach(element => {
                element.date = element.date ? new Date(element.date + 'Z') : null;
                 });
              this.notificationList = res.responseObject;
              if (this.notificationList && this.notificationList.length > 0) {
                this.notificationCount = this.notificationList.length; 
              }
              else{
                this.notificationCount = 0;
              }
               this.cdr.detectChanges();
            }
          }
        );
      }
    }
  }
  viewNotification(notification)
  {
    let modelHeadermsg=this.translate.instant("lblNotificationDetails");
    const modalRef = this.modalService.open(NotificationViewComponent, {size: 'lg',centered:true});
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.regNumber = notification.licensePlateNo;
    modalRef.componentInstance.dealer = notification.dealerName;
    modalRef.componentInstance.notificationList = notification;
    modalRef.result.then((_result) => { 
      //modal result
    }, (_reason) => {
      if(!(notification.isRead))
      {
          this.markAsRead(notification);
      }
    });
  }
  async markAsRead(notification){
    if (this.headerInfo) {
      const userId = this.headerInfo.customerGuid;
      if (userId) {
        this.spinner.show();
        this.orderService.notificationMarkAsRead(notification.notificationId).subscribe(          
          (response)=>{
            if (response) {
              this.GetCustomerNotifications();
            }
          },
          (_error)=>{
            this.spinner.hide();
          },
          ()=>{
            this.spinner.hide();
          },
        );
      }
    }
  }

  //#endregion

}
